import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// 시연용 한국어(2026-10-22 — src/demo/korean.ts): devnet 빌드의 VITE_DEMO_KOREAN=true 이고 브라우저가 한국어일 때만. 출시 빌드는 영어 그대로
if (import.meta.env['VITE_DEMO_KOREAN'] === 'true' && navigator.language.toLowerCase().startsWith('ko')) {
  void import('./demo/korean').then((m) => m.startKorean())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
